<template>
  <div>
    <div v-if="false">
      <h1>Diabetes</h1>
      <p>Ya queda menos!</p>
    </div>

    <!-- AI Insight -->
    <div v-if="coach && coach.focus">
      <v-alert
        type="info"
        elevation="2"
        icon="mdi-creation"
        style="font-size: 90%"
        @click="coach_expand = !coach_expand"
      >
        {{ coach.focus }}
      </v-alert>
    </div>

    <div v-else-if="loading_coach">
      <v-alert
        type="info"
        elevation="2"
        icon="mdi-creation"
        style="font-size: 90%"
        @click="coach_expand = !coach_expand"
      >
        Revisando tus últimas comidas...
      </v-alert>
    </div>
    <!-- AI bottom sheet -->
    <v-bottom-sheet v-model="coach_expand" scrollable>
      <v-card>
        <v-card-title> <v-icon color="orange" class="mr-2">mdi-creation</v-icon> AI Coach </v-card-title>
        <v-card-text>
          <div style="padding-bottom: 30px">
            {{ coach.reaction }}
          </div>

          <div style="font-weight: 800; font-size: 130%; margin-bottom: 10px">Más ideas</div>
          <div v-for="tip in coach.tips" :key="tip.tip" style="padding-bottom: 20px">
            <div style="font-weight: 500">
              {{ tip.tip }}
            </div>
            <div>
              {{ tip.explanation }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>

    <!-- tabs-->
    <div>
      <v-chip-group v-model="tab">
        <v-chip v-for="type in types" :key="type.value" filter label class="mb-1" :value="type.value">{{
          type.text
        }}</v-chip>
      </v-chip-group>

      <v-chip-group v-model="tab_what" v-if="tab == 'intake'">
        <v-chip v-for="item in intakes" :key="item.value" filter label class="mb-1" :value="item.value">{{
          item.text
        }}</v-chip>
      </v-chip-group>
    </div>

    <!-- loading -->
    <div>
      <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
    </div>
    <!-- events -->
    <div v-if="false">{{ events }}</div>

    <!-- list as cards -->
    <div class="card-list">
      <div
        class="card"
        v-for="event in events.filter((e) => (e.type == tab || !tab) && (e.what == tab_what || !tab_what))"
        :key="event.id"
        @click="editEvent(event)"
      >
        <div class="card-header" v-if="cardHeader(event)">
          {{ cardHeader(event) }}
        </div>
        <div class="card-title">{{ cardTitle(event) }}</div>
        <div class="card-subtitle">{{ cardSubtitle(event) }}</div>
        <div class="card-footer">
          <div class="left">{{ cardLeft(event) }}</div>
          <div class="right">{{ cardRight(event) }}</div>
        </div>
      </div>
      <!-- Repeat for more cards -->
    </div>

    <!-- list events -->
    <div v-if="false">
      <v-list>
        <v-list-item
          v-for="event in events.filter((e) => e.type == tab || !tab)"
          :key="event.id"
          @click="editEvent(event)"
        >
          <v-list-item-content v-if="event.type == 'meal'">
            <v-list-item-title> {{ event.meal }} </v-list-item-title>
            <v-list-item-subtitle>
              {{ event.value }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-list-item-title>
              <b>{{ types.find((x) => x.value == event.type).text }}:</b> {{ event.value }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <span>{{ event.when.replace('T', ' ') }}</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>

    <!--add button-->
    <v-fab-transition>
      <v-btn fab bottom right fixed color="primary" @click="addNewItem" :loading="loading">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>

    <!-- edit dialog -->
    <v-bottom-sheet v-model="editing">
      <DiabetesEventEdit :id="item_edit.id" :type="item_edit.type" @done="done($event)" />
    </v-bottom-sheet>

    <v-dialog v-if="false && editing" v-model="editing" scrollable max-width="600">
      <DiabetesEventEdit :id="item_edit.id" :type="item_edit.type" @done="done($event)" />
    </v-dialog>
  </div>
</template>

<script>
import api from '@/assets/api'
import { v4 as uuidv4 } from 'uuid'
import DiabetesEventEdit from './DiabetesEventEdit.vue'
export default {
  components: {
    DiabetesEventEdit,
  },
  data() {
    return {
      tab: 'meal',
      tab_what: '',
      loading: false,
      loading_coach: false,
      coach: '',
      events: [],
      editing: false,
      coach_expand: false,
      item_edit: {},
      types: [
        { value: 'meal', text: 'Comidas' },
        { value: 'glucose', text: 'Glucosa' },
        { value: 'exercise', text: 'Ejercicio' },
        { value: 'intake', text: 'Intake' },
      ],
      intakes: [
        { value: 'water', text: 'Agua', units: ['vaso', 'vasos'] },
        { value: 'fruit', text: 'Fruta', units: ['pieza', 'piezas'] },
        { value: 'milk', text: 'Leche', units: ['vaso', 'vasos'] },
        { value: 'vegetables', text: 'Verduras', units: ['ración', 'raciones'] },
      ],
    }
  },
  methods: {
    done(shallRefresh) {
      this.editing = false
      if (shallRefresh) this.fetchEvents()
    },
    async fetchEvents() {
      this.loading = true
      let x = await api.apiFetch('/diabetes/events')
      if (x.ok) {
        this.events = await x.json()
      }
      this.loading = false
    },
    editEvent(event) {
      this.item_edit = { ...event }
      this.editing = true
    },
    async addNewItem() {
      this.item_edit = {
        id: uuidv4(),
        type: this.tab,
        /*value: 10,
        source: 'paraguas', //from where this is created as new item.
        when: this.getCurrentDateTimeLocal(),
        */
      }
      this.editing = true
    },
    cardRight(event) {
      return event.when.replace('T', ' ')
    },
    cardLeft(event) {
      if (event.type == 'glucose') {
        return event.meal_context + ' ' + event.meal
      }
      if (event.type == 'meal') {
        //if (event.rating) return event.rating + ' ⭐'
        if (event?.coach?.score) return event.coach.score + ' ⭐'
        return ''
      }

      if (event.type == 'exercise') {
        return event.what + ' / ' + ['Relajado', 'Medio', 'Intenso'][event.intensity - 1]
      }

      if (event.type == 'intake') {
        return `${event.what} (${event.notas})`
      }

      return event.type
    },
    formatTime(minutes) {
      if (minutes < 60) {
        return minutes + ' min'
      } else {
        const h = Math.floor(minutes / 60)
        const m = minutes % 60
        return `${h}hr ${m}min`
      }
    },
    cardSubtitle(event) {
      if (event.type == 'meal') {
        return event.value
      }
      return ''
      /*
      if (event.type == 'glucose') {
        return event.meal_context + ' ' + event.meal
      }
      if (event.type == 'meal') {
        return event.meal
      }*/
      //return ''
    },
    cardTitle(event) {
      const v = event.value

      if (event.type == 'meal') {
        return event.meal
      }
      if (event.type == 'glucose') {
        return v + ' mg/dL'
      }

      if (event.type == 'exercise') {
        return this.formatTime(event.value)
      }

      if (event.type == 'intake') {
        const e = this.intakes.find((x) => x.value == event.what)
        if (e) {
          const i = event.value == 1 ? 0 : 1
          let unitt = e.units[i]
          return v + ' ' + unitt
        }
      }
      return v
    },
    cardHeader(event) {
      return ''
    },
    async fetchCoachMessage() {
      this.loading_coach = true
      const x = await api.apiFetch('/diabetes/coach?t=focus')
      if (x.ok) {
        this.coach = await x.json()
      }
      this.loading_coach = false
    },
  },

  mounted() {
    this.fetchEvents()
    this.fetchCoachMessage()
  },
}
</script>

<style scoped>
/* Card container (stacked vertically) */
.card-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* Individual card style */
.card {
  background-color: white;
  border: 1px solid #f0f0f0; /* Light border for better visibility */
  border-radius: 8px; /* Slightly smaller border-radius for a more compact look */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Subtle shadow for elevation */
  padding: 15px; /* Reduce padding inside cards for mobile */
  margin: 0;
  transition: box-shadow 0.3s ease-in-out;
  cursor: pointer;
}

.card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

/* Header (breadcrumb-like) */
.card-header {
  font-size: 13px; /* Smaller font for mobile */
  color: #555;
  font-weight: 500;
  padding: 4px 0;
  border-bottom: 1px solid #f0f0f0;
}

/* Title and subtitle */
.card-title {
  font-size: 18px; /* Slightly smaller title for better mobile fit */
  font-weight: bold;
  color: #333;
  margin: 8px 0;
}

.card-subtitle {
  font-size: 14px; /* Smaller subtitle font */
  color: #555;
  margin-bottom: 10px;
}

/* Footer with left and right-aligned content */
.card-footer {
  display: flex;
  justify-content: space-between;
  font-size: 13px; /* Reduced font size for mobile */
  color: #777;
  margin-top: 0px;
  padding-top: 2px;
}

.card-footer .left {
  color: #aaa;
  color: #555;
  font-size: 14px; /* Smaller subtitle font */
}

/* Footer right side (timestamp) */
.card-footer .right {
  color: #aaa;
}
</style>
